import { APIClient } from './api_helper';
import * as url from './url_helper';

const api = new APIClient();

const replaceParam = (url, param, value) => {
  return url.replace(param, value);
};

export const login = (user, pass, recaptchaToken, location) =>
  api.create(url.SESSION_LOGIN, { email: user, password: pass, recaptchaToken, location });
export const confirmTwoFactor = (pendingToken, code) =>
  api.create(url.SESSION_2FA_CONFIRM, { pendingToken, code });
export const resendTwoFactor = (pendingToken) => api.create(url.SESSION_2FA_RESEND, { pendingToken });
export const changeExpiredPassword = (passwordChangeToken, newPassword, recaptchaToken, location) =>
  api.create(
    url.SESSION_PASSWORD_EXPIRED_CHANGE,
    {
      passwordChangeToken,
      new_password: newPassword,
      recaptchaToken,
      location,
    },
    { skipErrorTransform: true }
  );

//AUDITS
export const getAudits = (params) => api.get(url.GET_AUDITS, params);
export const getAuditById = (id) =>
  api.get(replaceParam(url.GET_AUDIT_BY_ID, ':id', id));

//AUDITS
export const getAccountTransactions = (params) => api.get(url.GET_ACCOUNT_TRANSACTION, params);
export const createAccountTransaction = (params) => api.create(url.CREATE_ACCOUNT_TRANSACTION, params);
export const getAccountTransactionSummary = (params) => api.get(url.GET_ACCOUNT_TRANSACTION_SUMMARY, params);

//ORDERS
export const getOrders = (params) => api.get(url.GET_ORDERS, params);
export const getOrder = (id) => api.get(replaceParam(url.GET_ORDER, ':id', id));
export const getOrderById = (id) =>
  api.get(replaceParam(url.GET_ORDER_BY_ID, ':id', id));
export const getOrdersFilters = () => api.get(url.GET_ORDERS_FILTERS);
export const getAnalyticalOrdersFilters = () =>
  api.get(url.ANALYTICAL_ORDERS_FILTERS);
export const simulateOrder = (params) => api.create(url.SIMULATE_ORDER, params);
export const createOrder = (params) => api.create(url.CREATE_ORDER, params);
export const updateOrder = (ticket, params) =>
  api.update(replaceParam(url.UPDATE_ORDER, ':external_id', ticket), params);
export const approveOrder = (ticket) =>
  api.create(replaceParam(url.APPROVE_ORDER, ':ticket', ticket));
export const cancelOrder = (external_id) =>
  api.create(replaceParam(url.CANCEL_ORDER, ':external_id', external_id));

//CUSTOMERS
export const getCustomers = (params) => api.get(url.GET_CUSTOMERS, params);
export const getCustomerReserves = (params) =>
  api.get(url.GET_CUSTOMERS_RESERVES, params);
export const getFilters = () => api.get(url.GET_CUSTOMERS_FILTERS);
export const getCustomer = (document, params) =>
  api.get(replaceParam(url.GET_CUSTOMER, ':document', document), params);
export const getCustomerStatement = (document, params) =>
  api.get(
    replaceParam(url.GET_CUSTOMER_STATEMENT, ':document', document),
    params
  );
export const getCustomerOperations = (document, params) =>
  api.get(
    replaceParam(url.GET_CUSTOMER_OPERATIONS, ':document', document),
    params
  );
export const getCustomerExpirations = (document, params) =>
  api.get(
    replaceParam(url.GET_CUSTOMER_EXPIRATIONS, ':document', document),
    params
  );
export const createCustomer = (customer) =>
  api.create(url.CREATE_CUSTOMER, customer);
export const updateCustomer = (document, customer) =>
  api.update(`${url.UPDATE_CUSTOMER}/${document}`, customer);
export const bulkUpdateCustomerWalletStatus = (customers_wallets, status) =>
  api.update(`${url.BULK_UPDATE_CUSTOMER_WALLET_STATUS}`, {
    customers_wallets,
    status_reason: 'a',
    status,
  });
export const batchUpdateCustomerWalletStatus = (data) =>
  api.create(`${url.BATCH_UPDATE_CUSTOMER_WALLET_STATUS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

export const batchImportIncentive = (data) =>
  api.create(`${url.CUSTOMER_IMPORTS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
export const sendToken = (document, params) =>
  api.create(
    replaceParam(url.SEND_CUSTOMER_TOKEN, ':document', document),
    params
  );
export const validateToken = (document, params) =>
  api.create(
    replaceParam(url.VALIDATE_CUSTOMER_TOKEN, ':document', document),
    params
  );

//WITHDRAWALS
export const getWithdrawals = (params) => api.get(url.GET_WITHDRAWALS, params);
export const getWithdrawal = (id) =>
  api.get(replaceParam(url.GET_WITHDRAWAL, ':id', id));
export const updateWithdrawal = (id, params) =>
  api.update(replaceParam(url.UPDATE_WITHDRAWAL, ':id', id), params);

//STRATEGIES
export const getAccountStrategy = () => api.get(url.GET_ACCOUNT_STRATEGY);
export const updateAccountStrategy = (params) =>
  api.update(url.GET_ACCOUNT_STRATEGY, params);
export const getStrategies = (params) => api.get(url.GET_STRATEGIES, params);
export const createStrategy = (params) => api.put(url.CREATE_STRATEGY, params);
export const getBlockedProducts = (params) =>
  api.get(url.GET_BLOCKED_PRODUCTS, params);
export const batchImportBlockedProducts = (data) =>
  api.create(`${url.BATCH_IMPORT_BLOCKED_PRODUCTS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
export const batchImportCatalogStrategy = (data) =>
  api.create(`${url.BATCH_IMPORT_STRATEGY_PRODUCTS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
export const updateBlockedProduct = (externalId, data) =>
  api.update(
    replaceParam(url.UPDATE_DELETE_BLOCKED_PRODUCT, ':external_id', externalId),
    data
  );
export const deleteBlockedProduct = (externalId) =>
  api.delete(
    replaceParam(url.UPDATE_DELETE_BLOCKED_PRODUCT, ':external_id', externalId)
  );
export const getStrategyProducts = () => api.get(url.GET_STRATEGY_PRODUCTS);
export const getStrategyDetails = (filters) =>
  api.get(`${url.GET_STRATEGY_DETAILS}${filters}`);
export const deleteStrategyProducts = (data) =>
  api.delete(url.DELETE_STRATEGY_PRODUCTS, { data });
export const getStrategyFilters = (params) =>
  api.get(url.GET_STRATEGY_FILTERS, params);

//CAMPAIGNS
export const getCampaigns = (params) => api.get(url.GET_CAMPAIGNS, params);
export const getCampaignById = (id) =>
  api.get(replaceParam(url.GET_CAMPAIGN_BY_ID, ':id', id));
export const getActiveCampaign = () => api.get(url.GET_ACTIVE_CAMPAIGN);
export const createCampaign = (data) => api.create(url.CREATE_CAMPAIGN, data);
export const updateCampaign = (id, data) =>
  api.update(replaceParam(url.UPDATE_CAMPAIGN, ':id', id), data);

//CATALOGS
export const getProducts = (params) => api.get(url.GET_PRODUCTS, params);
export const getCategories = (params) => api.get(url.GET_CATEGORIES, params);
export const deleteProduct = (id) =>
  api.delete(replaceParam(url.DELETE_PRODUCT, ':id', id));
export const batchImportProducts = (data) =>
  api.create(`${url.BATCH_IMPORT_PRODUCTS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

//INCENTIVES
export const getIncentiveGroups = (params) =>
  api.get(url.GET_INCENTIVE_GROUPS, params);
export const getAllIncentiveGroups = (params) =>
  api.get(url.GET_ALL_INCENTIVE_GROUPS, params);
export const getIncentiveGroup = (id, params) =>
  api.get(replaceParam(url.GET_INCENTIVE_GROUP, ':groupId', id), params);
export const getIncentiveGroupUsers = (id) =>
  api.get(replaceParam(url.GET_INCENTIVE_GROUP_USERS, ':groupId', id));
export const createIncentiveGroup = (params) =>
  api.create(url.CREATE_INCENTIVE_GROUP, params);
export const createIncentive = (params) =>
  api.create(url.CREATE_INCENTIVE, params);
export const batchImportIncentiveApi = (data) =>
  api.create(`${url.IMPORT_INCENTIVE}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
export const validateIncentiveFileApi = (data) =>
  api.create(`${url.VALIDATE_INCENTIVE_FILE}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
export const deleteGroup = (groupId) =>
  api.delete(replaceParam(url.DELETE_GROUP, ':groupId', groupId));
export const cancelIncentive = (id) =>
  api.create(replaceParam(url.CANCEL_INCENTIVE, ':id', id));
export const getSmartIncentives = () => api.get(url.GET_SMART_INCENTIVES);
export const putSmartIncentives = (id, params) =>
  api.put(replaceParam(url.PUT_SMART_INCENTIVES, ':id', id), params);
export const getIncentiveDetailsFilters = () =>
  api.get(url.GET_INCENTIVE_DETAILS_FILTERS);

//Users
export const getUsers = (params) => api.get(url.GET_USERS + (params ?? ''));
export const getUsersFromStore = (storeId) =>
  api.get(replaceParam(url.GET_USERS_FROM_STORE, ':id', storeId));
export const getRoles = (params) => api.get(url.GET_ROLES, params);
export const getRolesPaginated = (params) =>
  api.get(url.GET_ROLES_PAGINATED, params);
export const createUser = (params) => api.create(url.CREATE_USER, params);
export const updateUser = (id, params) =>
  api.update(replaceParam(url.UPDATE_USER, ':id', id), params);
export const updatePassword = (params) =>
  api.update(url.UPDATE_PASSWORD, params);
export const getRecoveryLink = (params) =>
  api.create(url.RECOVERY_USER, params);
export const verifyToken = (token) =>
  api.get(replaceParam(url.RECOVERY_VERIFIY_TOKEN, ':token', token));
export const createNewPassword = (params) =>
  api.update(url.RECOVERY_PASSWORD, params);
export const batchDeactivateUsers = (data) =>
  api.create(`${url.IMPORT_DEACTIVATE_USERS}`, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

//Results
export const getHome = (params) => api.get(url.GET_HOME, params);

//Communications
export const getCommunicationRules = (params) =>
  api.get(url.GET_COMMUNICATION_RULES, params);
export const getCommunicationRulesByChannel = (channel) =>
  api.get(`${url.GET_COMMUNICATION_RULES}?channel=${channel}`);
export const getCommunicationTemplates = (params) =>
  api.get(url.GET_COMMUNICATION_TEMPLATES, params);
export const getCommunicationTemplate = (id) =>
  api.get(replaceParam(url.GET_COMMUNICATION_TEMPLATE, ':id', id));

export const updateCommunicationTemplate = (id, payload) =>
  api.put(replaceParam(url.UPDATE_COMMUNICATION_TEMPLATE, ':id', id), payload);

export const updateCommunicationTemplateAssociatedRules = (id, ids) =>
  api.create(
    replaceParam(url.UPDATE_COMMUNICATION_TEMPLATE_RULES, ':id', id),
    ids
  );
export const getCommunicationTemplateAssociatedRules = () =>
  api.get(url.GET_COMMUNICATION_RULES);
export const getTemplateVariables = () => api.get(url.GET_TEMPLATE_VARIABLES);
export const getCommunicationFilters = () =>
  api.get(url.GET_COMMUNICATION_FILTERS);

export const getShippingHistory = (params) =>
  api.get(url.GET_SHIPPING_HISTORY, params);
export const getShippingHistoryFilters = (params) =>
  api.get(url.GET_SHIPPING_HISTORY_FILTERS, params);

//INDICATORS
export const getBillingIndicators = (params) =>
  api.get(url.GET_INDICATORS_BILLING, params);
export const getConsumersIndicators = (params) =>
  api.get(url.GET_INDICATORS_CONSUMERS, params);
export const getCheckingAccountIndicators = (params) =>
  api.get(url.GET_INDICATORS_CHECKING_ACCOUNT, params);

//STORES
export const createStore = (params) => api.create(url.CREATE_STORE, params);
export const getStores = (params) => api.get(url.GET_STORES, params);
export const getStore = (id) => api.get(replaceParam(url.GET_STORE, ':id', id));
export const getStoreUsers = (id, qs) =>
  api.get(replaceParam(url.GET_STORE_USERS + qs, ':id', id));
export const getStoreUsersAll = (id, qs) =>
  api.get(replaceParam(url.GET_STORE_USERS_ALL + qs, ':id', id));
export const patchStoreUsers = (id, users) =>
  api.update(replaceParam(url.PATCH_STORE_USERS, ':id', id), { users });
export const getStoresRaw = (params) => api.get(url.GET_STORES_RAW, params);

//REPORTS
export const getReportExport = (params) => api.get(url.REPORT_EXPORT, params);
export const reportExport = (params) => api.create(url.REPORT_EXPORT, params);

//LEAD CAPTURE
export const getLeadCaptureConfiguration = () => api.get(url.CAPTURE_WALLET);
export const setLeadCaptureConfiguration = (params) =>
  api.update(url.CAPTURE_WALLET, params);

//MY WALLET
export const getMyWalletConfiguration = () => api.get(url.MY_WALLET);
export const setMyWalletConfiguration = (params) =>
  api.put(url.MY_WALLET, params);

//INTEGRATIONS
export const getIntegrations = () => api.get(url.GET_INTEGRATIONS_NON_CACHED);
export const putIntegration = (params) => api.put(url.PUT_INTEGRATION, params);
export const getIntegrationStatus = () => api.get(url.GET_INTEGRATION_STATUS);

//GENERAL SETTINGS
export const getGeneralSettings = () => api.get(url.GET_GENERAL_SETTINGS);
export const getAllAccountSettings = () =>
  api.get(url.GET_ALL_ACCOUNT_SETTINGS);
export const updateGeneralSettings = (params) => async (dispatch) => {
  try {
    const response = await api.update(url.UPDATE_GENERAL_SETTINGS, params);
    dispatch({ type: 'UPDATE_GENERAL_SETTINGS_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: 'UPDATE_GENERAL_SETTINGS_FAILURE', payload: error });
    throw error;
  }
};
// TWO-FACTOR AUTHENTICATION
export const getTwoFactorConfiguration = () => api.get(url.CONFIGURATIONS_2FA);
export const updateTwoFactorConfiguration = (enabled) =>
  api.update(url.CONFIGURATIONS_2FA, { values: [{ key: 'enabled', value: enabled }] });

// MANAGER PANEL
export const getSalesCardsData = (params) => api.get(url.ORDERS_REPORT, params);
export const getSalesChartData = (params) =>
  api.get(url.ORDERS_REPORT_BY_DATE, params);
export const getCashbackCardsData = (params) =>
  api.get(url.ORDERS_CASHBACK_REPORT, params);
export const getCashbackChartData = (params) =>
  api.get(url.ORDERS_CASHBACK_REPORT_BY_DATE, params);
export const getCommunicationCards = (params) =>
  api.get(url.COMMUNICATIONS_REPORT, params);

export const getCreditsCardsData = (params) =>
  api.get(url.CREDITS_REPORT, params);

export const getCreditsChartsData = (params) =>
  api.get(url.CREDITS_REPORT_BY_DATE, params);

export const getCommunicationCardsData = (params) =>
  api.get(url.COMMUNICATIONS_REPORT, params);
export const getCommunicationChartsData = (params) =>
  api.get(url.COMMUNICATIONS_REPORT_BY_DATE, params);

// Mock data for Revenue Intelligence KPIs
const MOCK_KPIS = {
  30: {
    items: [{
      repeat_customers: {
        repeat_customer_rate: 0.32,
        customers_2_plus_buys: 1120,
        customers_1_buy: 2380,
        repeat_customer_w_cb_rate: 0.35,
        repeat_customer_wo_cb_rate: 0.28,
      },
      order_frequency: {
        order_frequency: 2.1,
        order_frequency_w_cb: 2.8,
        active_customers: 3500,
        total_orders: 7350,
      },
      revenue: {
        total_revenue: 105000000,
        total_revenue_w_cb: 73500000,
        perc_revenue_w_cb: 0.70,
        total_revenue_mom_rel: 0.12,
      },
      average_ticket: {
        avg_ticket_cent: 14285,
        avg_ticket_w_cb_cent: 15750,
      },
      customer_distribution: {},
      retention: {},
      sanity_checks: {}
    }]
  },
  60: {
    items: [{
      repeat_customers: {
        repeat_customer_rate: 0.38,
        customers_2_plus_buys: 1680,
        customers_1_buy: 2720,
        repeat_customer_w_cb_rate: 0.41,
        repeat_customer_wo_cb_rate: 0.33,
      },
      order_frequency: {
        order_frequency: 2.4,
        order_frequency_w_cb: 3.2,
        active_customers: 4400,
        total_orders: 10560,
      },
      revenue: {
        total_revenue: 210000000,
        total_revenue_w_cb: 147000000,
        perc_revenue_w_cb: 0.70,
        total_revenue_mom_rel: 0.18,
      },
      average_ticket: {
        avg_ticket_cent: 14850,
        avg_ticket_w_cb_cent: 16500,
      },
      customer_distribution: {},
      retention: {},
      sanity_checks: {}
    }]
  },
  90: {
    items: [{
      repeat_customers: {
        repeat_customer_rate: 0.42,
        customers_2_plus_buys: 2100,
        customers_1_buy: 2900,
        repeat_customer_w_cb_rate: 0.45,
        repeat_customer_wo_cb_rate: 0.37,
      },
      order_frequency: {
        order_frequency: 2.7,
        order_frequency_w_cb: 3.5,
        active_customers: 5000,
        total_orders: 13500,
      },
      revenue: {
        total_revenue: 315000000,
        total_revenue_w_cb: 220500000,
        perc_revenue_w_cb: 0.70,
        total_revenue_mom_rel: 0.22,
      },
      average_ticket: {
        avg_ticket_cent: 15200,
        avg_ticket_w_cb_cent: 17100,
      },
      customer_distribution: {},
      retention: {},
      sanity_checks: {}
    }]
  }
};

const getMockKpisData = (windowSizeDays) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(MOCK_KPIS[windowSizeDays] || MOCK_KPIS[30]);
    }, 500); // Simulate network delay
  });
};

// KPIs - Revenue Intelligence Dashboard
export const getKpisDataApi = (params) => {
  const windowSizeDays = params?.filters?.windowSizeDays || 30;
  if (process.env.REACT_APP_USE_MOCK_KPIS === 'true') {
    return getMockKpisData(windowSizeDays);
  }
  return api.get(url.KPIS_REPORT, params);
};
